import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const StyledText = styled.span `
    font-weight: 700;
    font-size: 22px;
    text-transform: uppercase;
`;
const ProgressDateText = ({ children }) => (_jsx(StyledText, { children: children }));
export default ProgressDateText;
